export const DDialogState = wcardinal.ui.DDialogState;